import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import escape from '../utils/escape';
import { sortUsersByName } from '../utils/sorting';
import { isInList } from '../utils/list';
import _ from 'lodash';

import ListItemForAutoUserInput from './ListItemForAutoUserInput';

import userActions from '../actions/userActionCreators';

require.ensure([], () => {
    require('./AutoTaskInput.less');
});

class AutoUserInput extends React.Component {

    constructor(props, context) {
        super(props, context);

        let users = this.props.users.filter(user => !isInList(this.props.bannedUserIDs, user.id));

        if (this.props.hideInactive) users = users.filter(user => user.weeklyQuota !== 0);

        users = _.orderBy(users, ['surname'], ['asc']);

        this.state = {
            blurTimeout: null,
            filteredUsers: users,
            focused: false,
            forcePopup: this.props.forceInitialPopup,
            displayNoSelectionError: this.props.displayNoSelectionError,
            selectedIndex: 0,
            scrollTop: 0,
            text: this.props.text,
            users: users
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        this.props.dispatch(userActions.setSelectedUser(null));
    }

    componentDidMount = () => {
        let node = ReactDOM.findDOMNode(this.refs.userField);
        let popupWidth = node.offsetWidth;
        let popupLeft = node.offsetLeft;
        let popupTop = node.offsetHeight + node.offsetTop - 1;

        // in tables we get unnaturally small left and top offsets so to place the popup we need to do some custom calculations
        // particulary in tab Project Managment
        if (node.offsetLeft < 6) {
            popupTop = node.offsetHeight * 2 - 1;

            if (this.props.id > 0)
                popupTop = node.offsetHeight * 2 - this.props.id * 1 + this.props.id * node.offsetHeight * 1.38;

            popupLeft += 15;
        }

        this.setState({
            popupWidth: popupWidth,
            popupLeft: popupLeft,
            popupTop: popupTop
        });
    }

    componentWillReceiveProps = (nextProps) => {
        let users = nextProps.users.filter(user => !isInList(nextProps.bannedUserIDs, user.id));

        if (nextProps.hideInactive) users = users.filter(user => user.weeklyQuota !== 0);

        users = _.orderBy(users, ['surname'], ['asc']);

        this.setState({
                users: users
            }, () => {
                this.filterUsers(ReactDOM.findDOMNode(this.refs.userField).value);
            }
        );
    }

    componentWillUnmount = () => { clearTimeout(this.state.blurTimeout); }

    // EVENT HANDLERS

    handleBlur = () => {
        this.setState({
            blurTimeout: setTimeout(() => {
                this.setState({
                    focused: false,
                    selectedIndex: 0,
                    forcePopup: false
                });
            }, 200)
        });
    }

    handleChange = (changeEvent) => {
        let text = changeEvent.target.value;

        this.props.dispatch(userActions.setSelectedUser(null));
        this.setState({
            text: text,
            selectedIndex: 0,
            scrollTop: 0,
            forcePopup: true,
            focused: true
        });

        if (this.props.handleTextChange) this.props.handleTextChange(text);

        this.filterUsers(text);

        if (text === "") this.clear();
    }

    handleClick = () => {
        if (this.state.focused) { this.setState({ forcePopup: true }); }
    }

    handleFocus = () => {
        this.props.dispatch(userActions.setSelectedUser(null));
        this.setState({
            focused: true,
            selectedIndex: 0
        });

        this.filterUsers(this.state.text);
    }

    handleKeyDown = (keyEvent) => {
        let newScrollTop = this.state.scrollTop;

        if (keyEvent.key === "Tab" && !(this.props.disableTab && this.state.selectedIndex == 0 && (!this.state.text || this.state.text.trim() === '')) ) {
            keyEvent.key = "Enter";
            this.handleKeyPress(keyEvent);
        } else if (keyEvent.key === "ArrowUp" && this.state.selectedIndex - 1 >= 0) {
            // calculate the new position by subtracing height of one item and then set it
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop - ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex - 1)]).scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            this.setState({
                selectedIndex: this.state.selectedIndex - 1,
                focused: true,
                scrollTop: newScrollTop
            });

        } else if (keyEvent.key === "ArrowDown" && this.state.selectedIndex + 1 < this.state.filteredUsers.length) {
            // calculate the new position by adding height of one item but watching that it doesn't go over max height
            if (this.refs.popup) {
                newScrollTop = this.state.scrollTop + ReactDOM.findDOMNode(this.refs["item" + (this.state.selectedIndex + 1)]).scrollHeight;
                let popupDOMNode = ReactDOM.findDOMNode(this.refs.popup);
                if (newScrollTop > popupDOMNode.scrollHeight) newScrollTop = popupDOMNode.scrollHeight;
                ReactDOM.findDOMNode(this.refs.popup).scrollTop = newScrollTop;
            }

            // filter since we are gonna show the popup list
            let filter = new RegExp(escape.escapeInput(this.state.text), 'i');

            this.setState({
                selectedIndex: this.state.selectedIndex + 1,
                focused: true,
                scrollTop: newScrollTop,
                filteredUsers: this.state.users.filter(user => {
                    return filter.test(user.username) || filter.test(user.givenName) || filter.test(user.surname) || filter.test(user.givenName + ' ' + user.surname);
                })
            });
        } else if (keyEvent.key === "Escape" && this.state.focused) {
            // don't close the create pill outside
            keyEvent.stopPropagation();

            this.setState({
                focused: false,
                forcePopup: false
            });
        }
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter" && this.state.focused) {
            let selectedUser = this.state.filteredUsers[this.state.selectedIndex];

            this.setState({
                text: selectedUser.givenName + ' ' + selectedUser.surname,
                selectedIndex: this.state.selectedIndex,
                scrollTop: 0,
                forcePopup: false,
                focused: false
            },
            this.handleMouseDown(this.state.selectedIndex));

            this.filterUsers(this.state.text.trim());

            keyEvent.stopPropagation();
        }
    }

    handleMouseDown = (selectedIndex) => {
        let user = this.state.filteredUsers[selectedIndex];

        // handleFunction is needed because for example, newProjectwidget uses multiple AutoUserInputs and current mapping to store can save only one selectedUser
        if (this.props.handleFunction) this.props.handleFunction(user);

        this.props.dispatch(userActions.setSelectedUser(user));

        if (this.props.keepAfterClick) {
            let text = user.givenName + ' ' + user.surname;
            this.setState({ text: text });
        } else {
            this.props.dispatch(userActions.setSelectedUser(null));
            this.setState({
                text: '',
                selectedIndex: 0,
                focused: false
            });
        }
    }

    handleMouseOver = (selectedIndex) => { this.setState({ selectedIndex: selectedIndex }); }

    handleScroll = () => {
        if (this.state.blurTimeout) {
            clearTimeout(this.state.blurTimeout);
            this.setState({ blurTimeout: null });
            ReactDOM.findDOMNode(this.refs.userField).focus();
        }
    }

    // OTHER METHODS

    clear = () => {
        if(this.props.handleTextChange)
            this.props.handleTextChange();

        this.props.dispatch(userActions.setSelectedUser(null));
        this.setState({
            text: "",
            selectedIndex: 0,
            scrollTop: 0,
            filteredUsers: this.state.users,
            focused: false,
            forcePopup: false
        });
    }

    filterUsers = (userInput) => {
        if (!userInput || userInput === "") {
            this.setState({ filteredUsers: this.state.users });
            return;
        }

        let filter = new RegExp(escape.escapeInput(userInput), 'i');

        this.setState({
            filteredUsers: this.state.users.filter((user) => {
                if (this.props.noFilter) return true;
                return filter.test(user.username) || filter.test(user.givenName) || filter.test(user.surname) || filter.test(user.givenName + ' ' + user.surname);
            })
        });
    }

    setText = (text) => { this.setState({ text: text }); }

    // RENDER METHOD

    render = () => {
        return (
            <span className={this.props.displayNoSelectionError ? "has-error" : ""}>
                <input
                    style={{display: "inline"}}
                    ref="userField"
                    type="text"
                    className="form-control"
                    value={this.state.text ? this.state.text : ""}
                    placeholder={this.props.placeholder}
                    readOnly={this.props.readOnly ? "readonly" : ""}
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                    onClick={this.handleClick}
                    onFocus={this.handleFocus}
                    onKeyDown={this.handleKeyDown}
                    onKeyPress={this.handleKeyPress}
                />

                {
                    this.props.readOnly ? "" :
                        this.props.enableClear && this.state.text && this.state.text !== ''
                            ? <a style={{"cursor" : "pointer", "paddingRight" : "20px", "marginTop" : "5px"}} onClick={this.clear} className="filter-clear">
                                  <span><span className="md-clear"/></span>
                              </a>
                            : null
                }

                {this.props.readOnly ? "" :
                    this.state.forcePopup && this.state.filteredUsers.length > 0
                    ?
                        (
                            <ul className="popup" onScroll={this.handleScroll} style={{ "maxHeight": "60%", "minHeight": "130px", "width": this.props.popoverScale ? this.state.popupWidth * this.props.popoverScale : this.state.popupWidth + "px", "top": this.state.popupTop + "px", "left": this.state.popupLeft + "px" }} ref="popup" onClick={this.handleClick}>
                                {
                                    this.state.filteredUsers.map((user, i) => {
                                        let classNames = classnames({
                                            'popup-text': i != this.state.selectedIndex,
                                            'popup-text-selected': i === this.state.selectedIndex
                                        });

                                        return (<ListItemForAutoUserInput
                                                    active={user.active}
                                                    classNames={classNames}
                                                    givenName={user.givenName}
                                                    id={user.id}
                                                    index={i}
                                                    key={user.id}
                                                    mouseDown={this.handleMouseDown.bind(this)}
                                                    mouseOver={this.handleMouseOver.bind(this)}
                                                    ref={"item" + i}
                                                    surname={user.surname}
                                                    username={user.username}
                                                   />);
                                    })
                                }
                            </ul>
                        )
                    : null
                }
            </span>
        );
    }
}

AutoUserInput.propTypes = {
    bannedUserIDs: PropTypes.array,
    disableTab: PropTypes.bool,
    dispatch: PropTypes.func,
    enableClear: PropTypes.bool,
    forceInitialPopup: PropTypes.bool,
    displayNoSelectionError: PropTypes.bool,
    handleFunction: PropTypes.func,
    handleTextChange: PropTypes.func,
    hideInactive: PropTypes.bool,
    id: PropTypes.number,
    keepAfterClick: PropTypes.bool,
    noFilter: PropTypes.bool,
    placeholder: PropTypes.string,
    popoverScale: PropTypes.number,
    readOnly: PropTypes.bool,
    selectedUser: PropTypes.object,
    text: PropTypes.string,
    users: PropTypes.array
};

AutoUserInput.defaultProps = {
    text: "",
    bannedUserIDs: [],
    forceInitialPopup: true
};

const mapStateToProps = (state) => {
    return {
        selectedUser: state.users.selectedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
  null,
  {withRef : true}
) (AutoUserInput);



/** WEBPACK FOOTER **
 ** ./src/app/components/AutoUserInput.js
 **/